export default __webpack_public_path__ + "5c4f8c7f11e4db7adaebd05945967862.pdf";